export default __webpack_public_path__ + "static/media/promo-banner-lending.9fb71fac.svg";